var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#FFC2DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.469 36.281A13.282 13.282 0 1 0 9.187 23 13.294 13.294 0 0 0 22.47 36.281zm-4.561-10.854 3.688-2.863V14.82a.873.873 0 0 1 1.746 0V23a.874.874 0 0 1-.34.69l-4.025 3.116a.873.873 0 0 1-1.07-1.38z",
    fill: "#EF0554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTime);
export default __webpack_public_path__ + "static/media/homeTime.8a8290d80ada2c05923ecde5f3b2a26e.svg";
export { ForwardRef as ReactComponent };